<div class="container">
  <main>
    <nav>
      <a
        class="rounded-btn-prev"
        role="button"
        routerLink="/mam/uploadReport"
      ></a>
      <span class="back">BACK TO MAM</span>
    </nav>

    <div class="graphics-video-preview">
      <video-container [videoUrl]="graphicsInfo.sampleVideo"></video-container>
    </div>

    <div class="graphics-name">{{ graphicsInfo?.name }} Preset</div>
    <div class="details">
      <div class="left-side">
        <!--<div class="aspect-ratio"><label>ASPECT RATIO:</label> 16:9</div>
                <div class="duration">00:04:00:00 (25fps)</div>-->
      </div>
      <div class="buttons">
        <!--div class="autopilot-btn"  role="button">Add to Autopilot </div>
                <div class="live-button" (click)="goLive.emit()">  Go Live Now </div-->
      </div>
    </div>
  </main>
  <footer>
    <label>SAVE YOUR CUSTOM GRAPHICS</label>
    <div>
      <input type="text" [(ngModel)]="graphicsInfo.name" />
      <ichannel-button
        [label]="saving ? 'Saving...' : 'Save'"
        [theme]="saving ? 'DIS' : 'DARK'"
        [callback]="onSave()"
      ></ichannel-button>
    </div>
  </footer>
</div>
